
import React from 'react';
import { Box, Select, Text, TextInput } from 'grommet';

const ALL_TEXT = '<vše>';

const setValue = (onChange, attributeId, attributeValue) => {
    if (onChange) {
        onChange(
            attributeId,
            (attributeValue !== ALL_TEXT) ? attributeValue : undefined
        );
    }
}

const FiltetAttributeLabel = ({title}) => {
    return <Text style={{width: '150px'}}>{title} :</Text>;
}

const SelectFilterAttribute = ({attributeId, onChange, renderOption, title, value, values}) => {
    const options = [
        ALL_TEXT,
        ...values
    ];

    return (
        <Box direction="row" align="center">
            <FiltetAttributeLabel title={title} />
            <Select
                style={{width: '250px'}}
                options={options}
                value={value ? value : ALL_TEXT}
                onChange={({ option }) => setValue(onChange, attributeId, option)}
            >
                {renderOption
                    ? (option) => renderOption(option)
                    : null
                }
            </Select>
        </Box>
    )
}

const TextFilterAttribute = ({attributeId, onChange, title, value}) => {
    return (
        <Box direction="row" align="center">
            <FiltetAttributeLabel title={title} />
            <Box>
                <TextInput
                    style={{width: '298px'}}
                    value={value ? value : ''}
                    onChange={(event) => setValue(onChange, attributeId, event.target.value)}
                />
            </Box>
        </Box>
    )
}

const FilterAttribute = ({filterItem, onChange, value}) => {
    return (filterItem.type === 'select')
        ? <SelectFilterAttribute
            attributeId={filterItem.id}
            onChange={onChange}
            title={filterItem.title}
            value={value}
            values={filterItem.values}
            renderOption={filterItem.renderOption}
        />
        : <TextFilterAttribute
            attributeId={filterItem.id}
            onChange={onChange}
            title={filterItem.title}
            value={value}
        />;
}

export default FilterAttribute;
